import { PermissionDto, UserRoleDto } from '@/api/generated';

import { RouteEnum } from './Route.model';
import { ROUTES_PERMISSIONS } from './routesPermissions.model';
import { ROUTES_ROLES } from './routesRoles.model';

interface RouteAccess {
  permissionsWithAccess?: PermissionDto[];
  rolesWithAccess: UserRoleDto[];
}

interface RouteUser {
  permissions: PermissionDto[];
  role: UserRoleDto;
}

export const hasRouteAccess = (
  { permissionsWithAccess, rolesWithAccess }: RouteAccess,
  user: RouteUser,
): boolean => {
  if (rolesWithAccess.length > 0 && !rolesWithAccess.includes(user.role)) {
    return false;
  }

  if (
    permissionsWithAccess &&
    permissionsWithAccess.length > 0 &&
    !permissionsWithAccess.some(permission => user.permissions.includes(permission))
  ) {
    return false;
  }

  return true;
};

export const getRouteAccess = (path: RouteEnum): Required<RouteAccess> => ({
  permissionsWithAccess: ROUTES_PERMISSIONS[path],
  rolesWithAccess: ROUTES_ROLES[path] ?? [],
});

export const canAccessRoute = (path: RouteEnum, user: RouteUser): boolean =>
  hasRouteAccess(getRouteAccess(path), user);
